// menu for admin mode, contains options to download database, upload database and logout

import React, { useState } from 'react'
import {MenuMenu,MenuItem,Button,Menu,Icon,HeaderContent,Header,DropdownMenu,DropdownItem,Dropdown} from 'semantic-ui-react'
import axios from "axios";

// components:
import UploadModal from './UploadModal';
import ConfirmationModal from './ConfirmationModal';

export default function AdminMenu({ user, logout }) {
  const hostingServer = `https://sugardb.cs.uct.ac.za/`;

  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [repopulated, setRepopulated] = useState(false);

  // download the database as a JSON file
  const handleDatabaseDownload = async () => {
    try {
      // fetch data from the server
      const response = await axios.get(`${hostingServer}api/carb_structures`, {
        responseType: 'json',
      });

      //remove ID field and __v field from JSON data
      const newData = response.data.map( (item) => {
        const {_id, __v, ...rest} = item
        return rest
      });

      // Convert the data to a JSON string with indentation for readability
      const data = JSON.stringify(newData, null, 2);

      // create a new Blob object
      const blob = new Blob([data], { type: 'application/json' });

      // create a new URL object
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'sugar-db.json';
      link.click();

      // clean up
      URL.revokeObjectURL(link.href);
      
    } catch (error) {
      console.error("Error downloading the database: " + error);
    }
  }

    return (
        <div>
          <Menu inverted size='large' style={{display:'flex', flexDirection:'column', borderRadius:'0vh', backgroundColor:"#393E46"}}>
              <h1 style={{color:'white', margin:'2vh'}}>SugarDB Admin Home</h1>  
              <p style={{color:'white'}}>Welcome { user ? user : 'admin' }</p>

              <div style={{display:'flex',marginRight:'2vh', marginLeft:'2vh'}}>
                <Header inverted as='h2'>
                    <Icon name='settings' />
                    <HeaderContent>
                      Review Entry Suggestions
                    </HeaderContent>
                  </Header>
              
                <MenuMenu position='right'>

                  <MenuItem>
                    <Dropdown text='More options'>
                      <DropdownMenu>
                        <DropdownItem icon='download' text='Download database' onClick={handleDatabaseDownload}/>
                        <DropdownItem icon='upload' text='Upload database' onClick={() => setOpenUploadModal(true)} />
                      </DropdownMenu>
                    </Dropdown>
                  </MenuItem>

                  <MenuItem>
                      <Button onClick={() => logout()} icon> <Icon name='logout' /> Logout</Button>
                  </MenuItem>
                  
                  <UploadModal open={openUploadModal} onClose={() => setOpenUploadModal(false)} setRepopulated={setRepopulated}/>

                  <ConfirmationModal open={repopulated} onConfirm={() => setRepopulated(false)} onClose={() => setRepopulated(false)} message='Database repopulated successfully' confirmText={'OK'} cancelTextBool={false}/>
                </MenuMenu>
              </div>

          </Menu>
      </div>
    )
}